import { includes, isEmpty, map, pull } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
class CustomSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false,
      selectedOptions: [],
    };
    this.isOptionSelected = this.isOptionSelected.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.toggleOption = this.toggleOption.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.toggleSingleSelect = this.toggleSingleSelect.bind(this);
  }

  toggleDropdown() {
    const { isOpened } = this.state;
    if (!isOpened) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
    this.setState({
      isOpened: !isOpened,
    });
  }

  handleOutsideClick(e) {
    const { multiSelect, isSingleSelect } = this.props;
    if (
      this.node &&
      this.node.contains(e.target) &&
      (multiSelect || isSingleSelect)
    ) {
      return;
    }
    this.toggleDropdown();
  }

  toggleOption(id) {
    const newSelections = [...this.state.selectedOptions];
    if (includes(newSelections, id)) {
      pull(newSelections, id);
    } else {
      newSelections.push(id);
    }
    this.setState({ selectedOptions: newSelections }, () =>
      this.props.onChange([...this.state.selectedOptions]),
    );
  }

  toggleSingleSelect(id) {
    this.setState({ selectedOptions: id }, () => {
      this.props.onChange(this.state.selectedOptions);
    });
  }

  clearSelection() {
    this.setState(
      {
        selectedOptions: [],
      },
      () => this.props.onChange([]),
    );
  }

  isOptionSelected(id) {
    // const { multiSelect, isSingleSelect } = this.props;
    const { selectedOptions } = this.state;
    return selectedOptions === id;
  }

  isAnyOptionSelected() {
    return !isEmpty(this.state.selectedOptions);
  }

  render() {
    const { name, options, isSingleSelect } = this.props;
    const { isOpened } = this.state;

    return (
      <div
        className="toggle-dd subhdr-stripes--ucase"
        ref={node => {
          this.node = node;
        }}
      >
        <button
          type="button"
          className={`toggle-dd__btn ${isOpened ? 'is-active' : ''}`}
          onClick={() => this.toggleDropdown()}
        >
          <i className="icon icon--arrow-down-gray toggle-dd-down" />{' '}
          <i className="icon icon--arrow-down-gray toggle-dd-up" />
          {name}
        </button>
        <div className={`toggle-dd__menu ${isOpened ? 'is-visible' : ''}`}>
          {this.isAnyOptionSelected() && (
            <button
              className="toggle-dd__clear"
              onClick={() => this.clearSelection()}
            >
              <span>×</span> Clear Filters
            </button>
          )}
          <ul className="toggle-dd-list list-reset">
            {map(options, option => (
              <li key={option.id}>
                <button
                  type="button"
                  className={`btn-icon toggle-dd-list__btn 
                    ${this.isOptionSelected(option.id) ? 'is-active' : ''}`}
                  onClick={() => {
                    // eslint-disable-next-line no-unused-expressions
                    isSingleSelect
                      ? this.toggleSingleSelect(option.id)
                      : this.toggleOption(option.id);
                  }}
                >
                  {option.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

CustomSelect.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  isSingleSelect: PropTypes.bool,
  multiSelect: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CustomSelect;
